export const DEFAULT_TEXT_STYLE = 'paragraph';
export const DEFAULT_FONT_FAMILY = 'inter';
